import { render, staticRenderFns } from "./LuckyRedBag.vue?vue&type=template&id=776a6374&scoped=true"
import script from "./LuckyRedBag.vue?vue&type=script&lang=js"
export * from "./LuckyRedBag.vue?vue&type=script&lang=js"
import style0 from "./LuckyRedBag.vue?vue&type=style&index=0&id=776a6374&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a6374",
  null
  
)

export default component.exports